import { render } from "./DeliveryEnd.vue?vue&type=template&id=aa12d44e"
import script from "./DeliveryEnd.vue?vue&type=script&lang=js"
export * from "./DeliveryEnd.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__